import { AppDispatch, AppStore } from "@/store/store";
import { GUID } from "@faro-lotv/foundation";
import { ProjectApi, UploadedFileData } from "@faro-lotv/service-wires";

type CommonParams = {
  /** Current app store */
  appStore: AppStore;
  /** Function used to update the store */
  dispatch: AppDispatch;
  /** Client of the ProjectAPI used to update the project */
  projectApi: ProjectApi;
  /** Id of the area under which the element will be created */
  areaId?: GUID;
};

export type CommonUpdateProjectParams = CommonParams & {
  /** Name of the element that will be created */
  name: string;
  /** Date of creation of the element */
  createdAt: Date;
  /** The main file to upload */
  file: File;
  /** Url to the new file */
  downloadUrl: string;
  /** Urls to additionally uploaded files */
  additionalUrls: string[];
  /** Unique string used to differentiate the created elements */
  md5Hash: string;
};

export type CommonUpdateProjectMultiFilesParams = CommonParams & {
  /** File to upload */
  files: File[];
  /** Url to the new file */
  uploadedFilesData: UploadedFileData[];
  /** Urls to additionally uploaded files */
  additionalUrls: string[];
};

/**
 * CAD spatial grid generation options
 */
export type CadSpatialGridOption = {
  /** The number of static chunks */
  numberOfStaticChunks: number;

  /** Byte size of the static chunk */
  staticChunkByteSize: number;

  /** Byte size of the dynamic chunk on disc */
  dynamicChunkByteFileSize: number;

  /** The size of the grid cells in meters */
  gridCellWidth: number;

  /** Byte size of the dynamic chunk on memory; optional as CadImporter will use a factor of dynamicChunkByteFileSize by default */
  dynamicChunkByteMemorySize?: number;

  /** true to restore legacy behavior when small chunks were not collated; default is false for new behavior */
  doNotCollateSmallChunks: boolean;
};

export enum UploadElementType {
  /** To be used when the file upload shouldn't trigger an update of the project */
  none = "None",
  cad = "Cad",
  gaussianSplats = "GaussianSplats",
  pointcloud = "Pointcloud",
  areaImage = "AreaImage",
  areaImageTiled = "AreaImageTiled",
  imageData = "ImageData",
  waypointWithImages = "WaypointWithImages",
  unplaced2dPhotos = "Unplaced2dPhotos",
}
